// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2575":"5c26f7d0","9849":"9d536994"}[chunkId] + ".chunk.css";
};